import { CONNECT_STATIC_MACRO_RENDER_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

export type ConnectStaticMacroRenderData = {
	contentId?: string;
	extensionKey?: string;
	macroId?: string;
	isConnectMacro?: boolean;
	macroRenderedOutput?: string | null;
};

const containsIframe = (macroRenderedOutput: string): boolean =>
	/<iframe(?:\s|>)/i.test(macroRenderedOutput);

const safelyTrackConnectStaticMacroExperience = (track: () => void): void => {
	try {
		track();
	} catch {
		// Telemetry must never block or alter macro rendering behaviour.
	}
};

export const ConnectStaticMacroExperienceTrackerSupport: {
	isTrackable(data: ConnectStaticMacroRenderData | null | undefined): boolean;
	start(data: ConnectStaticMacroRenderData | null | undefined): void;
	succeed(): void;
	fail(error: Error): void;
	abort(reason: string): void;
} = new (class ConnectStaticMacroExperienceTrackerSupport {
	isTrackable(data: ConnectStaticMacroRenderData | null | undefined): boolean {
		const outputContainsIframe =
			typeof data?.macroRenderedOutput === 'string'
				? containsIframe(data.macroRenderedOutput)
				: false;
		return Boolean(data?.isConnectMacro && data?.macroRenderedOutput && !outputContainsIframe);
	}

	start(data: ConnectStaticMacroRenderData | null | undefined): void {
		safelyTrackConnectStaticMacroExperience(() => {
			getExperienceTracker().start({
				name: CONNECT_STATIC_MACRO_RENDER_EXPERIENCE,
				attributes: {
					contentId: data?.contentId,
					extensionKey: data?.extensionKey,
					macroId: data?.macroId,
				},
			});
		});
	}

	succeed(): void {
		safelyTrackConnectStaticMacroExperience(() => {
			getExperienceTracker().succeed({
				name: CONNECT_STATIC_MACRO_RENDER_EXPERIENCE,
			});
		});
	}

	fail(error: Error): void {
		safelyTrackConnectStaticMacroExperience(() => {
			getExperienceTracker().fail({
				name: CONNECT_STATIC_MACRO_RENDER_EXPERIENCE,
				error,
			});
		});
	}

	abort(reason: string): void {
		safelyTrackConnectStaticMacroExperience(() => {
			getExperienceTracker().abort({
				name: CONNECT_STATIC_MACRO_RENDER_EXPERIENCE,
				reason,
			});
		});
	}
})();
